<template>
		<input 
		:name="name"
		:checked="value"
		type="checkbox"/>
</template>

<script>
		
	import bus from '@/bus/event-bus.js'

	export default {
		props: ['value', 'name'],

		mounted() {
			var check = $(this.$el);

			check.iCheck({
				checkboxClass: 'icheck-pink'
			})

			$(this.$el).find(".text").click(() => {
				check.iCheck('check')
			})

			check.on('ifChanged', () => {
				this.$emit('input', check.is(':checked'))
			})


		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/Check.vue